<template>
    <h1 :class="appState" aria-live="polite" class="text-slider text-center text-white font-medium uppercase tracking-wider text-2xl vt:text-4xl">
        <span v-html="currentSlide"></span>
    </h1>
    <div class="controls w-full absolute flex justify-center left-0">
        <ul class="flex">
            <li class="mx-2" v-for="(headline, i) in headlines">
                <button @click="goTo(i)" :aria-label="`Go to slide ${i + 1}`" :class="i == currentIndex ? 'active' : 'inactive'" class="w-2 h-2 border-white border-solid border appearance-none">
                </button>
            </li>
        </ul>
    </div>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';

export default {

    props: ['headlines'],
    
    setup(props) {

        const currentIndex = ref(0);
        const appState = ref('idle');
        let loop;

        const currentSlide = computed(() => {
            if (!props.headlines.length) {
                return null;
            }
            return props.headlines[currentIndex.value];
        });

        const nextSlide = computed(() => {
            if (!props.headlines.length) {
                return null;
            }
            return (currentIndex.value === props.headlines.length - 1)
                ? props.headlines[0]
                : props.headlines[currentIndex.value + 1];
        });

        const next = () => {
            currentIndex.value = (currentIndex.value === props.headlines.length - 1)
                ? 0
                : currentIndex.value + 1;
        };

        const slideIt = (i = null) => {
            appState.value = 'transitioning';
            window.wait(500).then(() => {
                if (i === null) {
                    next();
                } else {
                    currentIndex.value = i;
                }
                appState.value = 'idle';
            });
        };

        onMounted(() => {
            loop = window.setInterval(() => {
                slideIt();
            }, 4000);
        });

        onBeforeUnmount(() => {
            window.clearInterval(loop);
        });

        const goTo = (i) => {
            window.clearInterval(loop);
            slideIt(i);
            loop = window.setInterval(() => {
                slideIt();
            }, 3000);
        };

        return {
            appState,
            currentIndex,
            currentSlide,
            goTo,
            nextSlide
        };

    }

}
</script>